module.exports = __webpack_public_path__ + "media/images/icon-pushkin-83c72ca0ceef0bfd43c9e52e49b1140b.svg";